import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import decodeJson from '@seccon/shared/utils/decodeJson';
import { ToastContext } from '@seccon/core/contexts/toast';
import { useMutation } from '@tanstack/react-query';
import CSRFContext from '@seccon/core/contexts/csrf';

function useEndSession () {
  const toastApi = React.useContext(ToastContext);
  const csrfToken = React.useContext(CSRFContext);
  const { id: sessionId } = useParams();

  const [searchParams] = useSearchParams();
  const facilityId = searchParams.get('facilityId') ?? '';

  return useMutation({
    mutationFn: () => (
      fetch(`/sessions/${ sessionId }/close`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'anti-csrf-token': csrfToken
        }
      }).then(decodeJson)
    ),
    onSuccess: () => {
      toastApi.success('Personnel comparison session ended successfully');

      setTimeout(() => {
        window.location.href = `/personnel/list?facilityId=${ facilityId }`;
      }, 3000);
    },
    onError: ({ body }) => {
      toastApi.error(body && body?.message ? `Error: ${ body.message }` : 'Unable to end Personnel comparison session. Please try again');
    }
  });
}

export default useEndSession;
